var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CompanySelect'),_vm._v(" "),(_vm.user.clientType == 2)?_c('CompanyList'):_vm._e(),_vm._v(" "),(_vm.user.clientType == 2)?_c('AddNewCompany'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }